import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { format } from "date-fns";
import th from "date-fns/locale/th";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerIcon from "./DatePickerIcon";
import DatePickerInput from "./DatePickerInput";

// ลงทะเบียนภาษาไทย
registerLocale("th", th);

const ThaiDatePicker = ({
  name,
  value,
  onChange,
  dateFormat,
  type,
  disable,
}) => {
  // const [selectedDate, setSelectedDate] = useState(new Date());

  // ฟังก์ชันสำหรับแสดงปีเป็น พ.ศ.
  const formatThaiYear = (date) => {
    const thaiYear = date.getFullYear() + 543;
    return thaiYear;
  };

  // const formatDateToBuddhistYear = (date) => {
  //     if (!date) return '';
  //     // ดึงวันและเดือนจาก date-fns
  //     const day = format(date, 'dd');
  //     const month = format(date, 'MM');
  //
  //     console.log('date=', date)
  //     // ดึงปีและแปลงเป็น พ.ศ.
  //     const thaiYear = date.getFullYear() + 543;
  //     return `${day}/${month}/${thaiYear}`;
  // };

  //  customInput={
  //  <input
  //      value={formatDateToBuddhistYear(selectedDate)}
  //      onChange={(e) => {/* ใช้ DatePicker จัดการ */}}
  //      style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '150px' }}
  //  />
  // }

  // customInput={customInput}
  return (
    <>
      <DatePicker
        name={name}
        selected={value}
        onChange={(date) => onChange(date)}
        dateFormat={dateFormat}
        locale="th"
        disabled={disable === undefined ? false : disable}
        customInput={
          type === "icon" ? (
            <DatePickerIcon disable={disable === undefined ? false : disable} />
          ) : (
            <DatePickerInput value={value} />
          )
        }
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{
              margin: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              {"<"}
            </button>
            <select
              value={date.getFullYear()}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {Array.from(
                { length: 10 },
                (_, i) => date.getFullYear() - 5 + i
              ).map((option) => (
                <option key={option} value={option}>
                  {formatThaiYear(new Date(option, 0, 1))}
                </option>
              ))}
            </select>

            <select
              value={date.getMonth()}
              onChange={({ target: { value } }) => changeMonth(value)}
            >
              {[
                "มกราคม",
                "กุมภาพันธ์",
                "มีนาคม",
                "เมษายน",
                "พฤษภาคม",
                "มิถุนายน",
                "กรกฎาคม",
                "สิงหาคม",
                "กันยายน",
                "ตุลาคม",
                "พฤศจิกายน",
                "ธันวาคม",
              ].map((option, i) => (
                <option key={i} value={i}>
                  {option}
                </option>
              ))}
            </select>

            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              {">"}
            </button>
          </div>
        )}
      />
    </>
  );
};

export default ThaiDatePicker;
